import { render, staticRenderFns } from "./PlayerCreditsSpecialistsSent.vue?vue&type=template&id=7977cbe8&scoped=true&"
import script from "./PlayerCreditsSpecialistsSent.vue?vue&type=script&lang=js&"
export * from "./PlayerCreditsSpecialistsSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7977cbe8",
  null
  
)

export default component.exports